module.exports = __webpack_public_path__ + "img/modal-img.e997b911.png";